/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_TitleInputs */

const en_svc_full_stack_web_apps_title = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-Stack Web Apps`)
};

const ar_svc_full_stack_web_apps_title = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطبيقات الويب المتكاملة`)
};

const bn_svc_full_stack_web_apps_title = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফুল-স্ট্যাক ওয়েব অ্যাপ`)
};

const de_svc_full_stack_web_apps_title = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-Stack-Web-Apps`)
};

const es_svc_full_stack_web_apps_title = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicaciones web de pila completa`)
};

const fr_svc_full_stack_web_apps_title = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applications Web Full-Stack`)
};

const pt_svc_full_stack_web_apps_title = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicativos Web Full Stack`)
};

const zh_svc_full_stack_web_apps_title = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全栈 Web 应用程序`)
};

const tr_svc_full_stack_web_apps_title = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam Yığın Web Uygulamaları`)
};

const ru_svc_full_stack_web_apps_title = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полнофункциональные веб-приложения`)
};

const pl_svc_full_stack_web_apps_title = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikacje internetowe z pełnym stosem`)
};

/**
* | output |
* | --- |
* | "Full-Stack Web Apps" |
*
* @param {Svc_Full_Stack_Web_Apps_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_title = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_title(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_title(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_title(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_title(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_title(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_title(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_title(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_title(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_title(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_title(inputs)
	return en_svc_full_stack_web_apps_title(inputs)
});
export { svc_full_stack_web_apps_title as "svc_full-stack-web-apps_title" }